import { Pipe, PipeTransform } from '@angular/core';

import { MachineCategory } from '../models/entities/machine-category.type';

@Pipe({
	name: 'categoryFilter'
})
export class CategoryFilterPipe implements PipeTransform {

	transform(categories: MachineCategory[], filterString: string = '', filterCategoryId: number): MachineCategory[] {

		if (!categories || (!filterString && !filterCategoryId)) {
			return categories;
		}

    return categories.filter(
      category =>
        (!filterCategoryId || category.Id === +filterCategoryId) &&
        (category.Machines.some(m => m.Title?.toLowerCase().includes(filterString.toLowerCase())) ||
        category.Machines.some(m => m.PhysicalAddress?.toLowerCase().includes(filterString.toLowerCase()) )||
        category.Name.toLowerCase().includes(filterString.toLowerCase()) ||
        category.Machines.some(m => m.Monitors?.some(mon => mon.MonitorTitle.toLowerCase().includes(filterString.toLowerCase()))))
    );
	}
}
